(() => {
  function init(root) {
    root.querySelectorAll('.header-product-search').forEach((search) => {
      if (search.dataset.initialized) return;
      search.dataset.initialized = 'true';
      const toggle = search.querySelector('summary');
      const input = search.querySelector('input[type="search"]');
      search.addEventListener('toggle', () => {
        if (search.open) input.focus();
      });
      search.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          search.open = false;
          toggle.focus();
          event.stopPropagation();
        }
      });
      search.addEventListener('focusout', (event) => {
        if (event.relatedTarget && !search.contains(event.relatedTarget)) search.open = false;
      });
      search.querySelector('form').addEventListener('submit', (event) => {
        input.value = input.value.trim();
        if (!input.value) {
          event.preventDefault();
          input.reportValidity();
        }
      });
    });
  }
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.header-product-search[open]').forEach((search) => {
      if (!search.contains(event.target)) search.open = false;
    });
  });
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
